<!--跟单-->
<template>
	<div class="page-body center-wrap">
		<div class="top-card">
			<div class="left-con txt-ali-cen txt-16">
				<span class="c2c-text">交易廣場</span>
				<span class="line"></span>
				<div class="item">
					<div>跟單總收益 <i class="el-icon-view"></i></div>
				</div>
				<!-- <span class="line"></span> -->
				<div class="item" style="margin-left: 20px;">
					<div class="">0.00<span>USDT</span></div>
					<div class="">
						<span>今日
							<span class="txt">0.00</span>
						</span>
					</div>
				</div>
				<span class="line"></span>
			</div>
			<div class="right-con dis-fle ali-cen cur-poi" @click="$nav.go('/pc/documentaryRecord')">
				<img src="@/assets/img-pc/45.1fa61580.svg">
				<span class="txt-14">我的跟單</span>
			</div>
		</div>

		<el-tabs v-model="activeName" @tab-click="handleClick" style="padding: 0 20px;">
			<el-tab-pane label="事件合约 " name="1"></el-tab-pane>
		</el-tabs>

		<ul class="list">
			<li class="item">
				<div class="item_top">
					<div class="item_top_left">
						<img src="https://v3.ptdemot.bio/uploads/f056827af159483b81d948bddd15efab.png" alt=""
							class="avatar">
						<div class="item_name">
							<div class="item_name_level">
								<span>aiden1</span>
								<span class="user_level">LV.9</span>
							</div>
							<div class="item_name_total">
								<img src="@/assets/img-pc/50.08469526.svg" alt="" class="icon-group">
								<span>2,365
									<span class="total_all">/5,000</span>
								</span>
								<span style="margin-left: 10px;">@010</span>
							</div>
						</div>
					</div>
					<button class="follow_btn following" @click="$nav.go('/pc/followOrderDetails')">跟單中</button>
				</div>
				<div class="underline-text">
					<span class="underline-apan">近90天交易員收益</span>
					<span>
						<span>總收益</span>
						<span class="value">+$3,850,701.53</span>
					</span>
				</div>
				<div class="line_wrap">
					<div class="line_num"><span>+5.61%</span></div>
				</div>
				<div class="chart-bar-base">
					<img src="https://v3.ptdemot.bio/assets/chart-bar-1.6c830a3b.svg" alt="" class="chart-bar">
				</div>
				<div class="item_bottom">
					<div class="item_bottom_left">
						<span>勝率</span>
						<span>98.75%</span>
						<span>帶單規模</span>
						<span>$14170511.73197</span>
					</div>
					<div></div>
				</div>
			</li>
			<li class="item">
				<div class="item_top">
					<div class="item_top_left"><img
							src="https://v3.ptdemot.bio/uploads/subp/ee8dcb08e01e4f7b8edccee0ce8f98e4.png" alt=""
							class="avatar">
						<div class="item_name">
							<div class="item_name_level"><span>bbb</span><span class="user_level">LV.2</span></div>
							<div class="item_name_total"><img src="@/assets/img-pc/50.08469526.svg" alt=""
									class="icon-group"><span>5,436
									<span class="total_all">/65,878</span></span><span
									style="margin-left: 10px;">@243</span></div>
						</div>
					</div><button class="follow_btn">跟單</button>
				</div>
				<div class="underline-text"><span class="underline-apan">近90天交易員收益</span><span><span>總收益</span><span
							class="value">+$5,659,234.98</span></span></div>
				<div class="line_wrap">
					<div class="line_num"><span>+34.04%</span></div>
				</div>
				<div class="chart-bar-base"><img src="https://v3.ptdemot.bio/assets/chart-bar-2.87559193.svg" alt=""
						class="chart-bar"></div>
				<div class="item_bottom">
					<div class="item_bottom_left">
						<span>勝率</span><span>58.76%</span><span>帶單規模</span><span>$542.081729</span>
					</div>
					<div></div>
				</div>
			</li>
			<li class="item">
				<div class="item_top">
					<div class="item_top_left"><img
							src="https://v3.ptdemot.bio/uploads/subp/1d4a20074c4143ccad32b78cc7a0a816.jpg" alt=""
							class="avatar">
						<div class="item_name">
							<div class="item_name_level"><span>daidan01</span><span class="user_level">LV.1</span></div>
							<div class="item_name_total"><img src="@/assets/img-pc/50.08469526.svg" alt=""
									class="icon-group"><span>323
									<span class="total_all">/34</span></span><span
									style="margin-left: 10px;">@123</span></div>
						</div>
					</div><button class="follow_btn">跟單</button>
				</div>
				<div class="underline-text"><span class="underline-apan">近90天交易員收益</span><span><span>總收益</span><span
							class="value">+$280.65</span></span>
				</div>
				<div class="line_wrap">
					<div class="line_num"><span>+32.38%</span></div>
				</div>
				<div class="chart-bar-base"><img src="https://v3.ptdemot.bio/assets/chart-bar-3.83c67609.svg" alt=""
						class="chart-bar"></div>
				<div class="item_bottom">
					<div class="item_bottom_left">
						<span>勝率</span><span>1.06%</span><span>帶單規模</span><span>$356.547927</span>
					</div>
					<div></div>
				</div>
			</li>
		</ul>
	</div>
</template>
<script>
	export default {
		components: {},
		data() {
			return {
				activeName: '1',
			};
		},
		mounted() {

		},
		beforeUnmount() {},
		methods: {
			handleClick() {},

		},
	};
</script>
<style lang="scss" scoped>
	.list {
		position: relative;
		display: flex;
		flex-wrap: nowrap;
		flex-direction: row;
		align-items: normal;
		justify-content: normal;
		padding: 15px 0 5px;
		flex-wrap: wrap;
		min-height: 480px;
		gap: 30px;
		list-style: none;

		.item {
			flex: none;
			width: calc(33.33333% - 20px);
			height: 267px;
			background-color: #12141e;
			border-radius: 18px;
			padding: 20px;
			position: relative;
			cursor: pointer;

			.item_bottom {
				height: 30px;
				border-radius: 15px;
				background: #1d1d24;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 5px 11px;
				margin-top: 8px;

				.item_bottom_left {
					color: #888;

					span {
						&:nth-child(2) {
							color: #fcfcfc;
							margin-right: 10px;
							margin-left: 5px;
						}

						&:nth-child(4) {
							color: #fcfcfc;
							margin-left: 5px;
						}
					}
				}
			}

			.line_wrap {
				span {
					&:first-child {
						color: #00f0ff;
						font-size: 24px;
						font-weight: 400;
						line-height: 30px;
					}
				}
			}

			.underline-text {
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: 100%;
				color: #888;
				line-height: 20px;
				margin-top: 12px;
				font-size: 12px;

				.value {
					color: #fcfcfc;
					margin-right: 10px;
				}
			}

			.item_top {
				display: flex;
				justify-content: space-between;
				align-items: center;

				.follow_btn {
					background: #00f0ff;
					color: #000;
					width: 80px;
					height: 40px;
					border-radius: 100px;
					cursor: pointer;
					line-height: 1;
					border-width: 0;

					&.following {
						border: 1px solid #00f0ff;
						background: rgba(0, 166, 9, .4);
						color: #00dd0c;
					}
				}

				.item_top_left {
					display: flex;
					align-items: center;
					justify-content: center;

					.avatar {
						width: 40px;
						height: 40px;
						border-radius: 50%;
						margin-right: 10px;
					}

					.item_name_total {
						display: flex;
						align-items: center;

						.icon-group {
							height: 14px;
						}

						.total_all {
							color: #888;
						}
					}

					.item_name_level {
						span {
							&:first-child {
								color: #00f0ff;
								font-size: 18px;
							}
						}

						.user_level {
							margin-left: 6px;
							width: 33px;
							height: 18px;
							padding: 1px 5px;
							font-weight: 600;
							border-radius: 100px;
							color: #a07300;
							background: linear-gradient(270deg, #fcdf7b, #f9cd4e);
						}
					}
				}
			}
		}
	}

	.top-card {
		width: 100%;
		height: 72px;
		border: 1px solid #252731;
		box-shadow: 0 0 10px rgba(0, 0, 0, .10196078431372549);
		padding: 0 16px 0 20px;
		margin: 20px 0;
		border-radius: 999px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: #fff;

		.right-con {
			padding: 10px 26px;

			img {
				margin-right: 6px;
			}
		}

		.left-con {
			display: flex;
			align-items: center;
			text-align: center;

			.c2c-text {
				color: #00f0ff;
				font-size: 24px;
				line-height: 40px;
			}

			span {
				color: #848e9c;
				font-size: 14px;

				.txt {
					color: #00f0ff;
				}
			}
		}

		.line {
			width: 2px;
			height: 14px;
			margin: 0 30px;
			background-color: #3c3e53;
		}
	}
</style>